import React, { useEffect, useState } from "react";
import {
  Stack,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Container,
  Badge,
} from "@mui/material";
import DehazeIcon from "@mui/icons-material/Dehaze";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { useSideBar } from "../../Context/SideBarProvider";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useNavigate } from "react-router-dom";
import { useRtl } from "../../Context/RtlProvider";
import { useNotifications } from "../../Context/NotificationContext";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { useSearch } from "../../Context/SearchProvider";
import StrinLocalized from "../../Language/language.lang";
import { getAll } from "../../Utils/getAll";
import strings from "../../Language/language.lang";
import axiosInstance from "../../HelperAxios/axios";
import { useTimeZoneMap } from "../../Context/TimeZone";
import { useHeaderContext } from "../../Context/HeaderProvider";
import ThemeSetting from "./ThemeSetting";
import { useTheme } from "../../hooks/useTheme";
import useProfileInfo from "../../hooks/useProfileInfo";
import useUserPermissions from "../../hooks/useUserPermissions";
import { canShowWalletHeader, getWalletHomePath } from "../../Utils/walletAccess";
import TimeEntryTimer from "../TimeEntries/TimeEntryTimer";
import AccountSwitcher from "./AccountSwitcher";

const Header = () => {
  const { headerData } = useHeaderContext();
  const { toggle } = useSideBar();
  const currentUser = useAuthUser();
  const navigate = useNavigate();
  const { unreadCount, markAllRead } = useNotifications();
  const [languaes, setLanguages] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const { getTimeZones } = useTimeZoneMap();
  const [user, setUser] = useState();
  const open = Boolean(anchorEl);
  const { rtl, changeToRtl, changeToLtr } = useRtl();
  const { search, setSearch } = useSearch();
  useEffect(() => {
    getAll(setLanguages, `language/select-list-active?platform=Portal`);
    // getAll(setUser, "user/get-user-profile");
    getTimeZones();
  }, []);
  const langFile = localStorage.getItem("langfile");
  const lang = localStorage.getItem("lang");
  const [theme] = useTheme();
  const storedProfile = useProfileInfo();
  const permissionsReady = useUserPermissions();

  useEffect(() => {
    // localStorage.remove("langfile");
    if (langFile) {
      if (langFile) {
        // localStorage.setItem("langfile", file.data);
        axiosInstance
          .get(`public/${langFile}`)
          .then((file) => {
            if (file) {
              const fileObj = file.data;
              const obj = { [lang]: fileObj };

              strings.setContent(obj);
            }
          })
          .catch((err) => console.log(err));
      }
      // else {
      //   axiosInstance
      //     .get(
      //       `${API_URL}language/get-language-by-alias?platform=${user.language.platform}&alias=${user.language.alias}`
      //     )
      //     .then((res) => {
      //       localStorage.setItem("langfile", res.data.file);
      //       axiosInstance
      //         .get(`public/${res.data.file}`)
      //         .then((file) => {
      //           if (file) {
      //             const fileObj = file.data;
      //             const obj = { [lang]: fileObj };

      //             strings.setContent(obj);
      //           }
      //         })
      //         .catch((err) => console.log(err));
      //     })
      //     .catch((err) => console.log(err));
      // }
    }
  }, [langFile]);

  // console.log("lang --------------", localStorage.getItem("langfile"));
  // const persian = "1707308692069.json"
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChangeToRtl = (item) => {
    if (item.file) {
      changeToRtl();

      localStorage.setItem("langfile", item.file);
      axiosInstance
        .get(`public/${item.file}`)
        .then((file) => {
          if (file) {
            const fileObj = file.data;
            const obj = { [item.alias]: fileObj };
            console.log(obj);
            strings.setContent(obj);
            strings.setLanguage(item.alias);

            localStorage.setItem("lang", item.alias);
            handleClose();

            // بعد از تکمیل تمام تغییرات
            location.reload();
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const handleChangeToLtr = (item) => {
    if (item.file) {
      changeToLtr();

      localStorage.setItem("langfile", item.file);
      axiosInstance
        .get(`public/${item.file}`)
        .then((file) => {
          if (file) {
            const fileObj = file.data;
            const obj = { [item.alias]: fileObj };
            strings.setContent(obj);
            strings.setLanguage(item.alias);

            localStorage.setItem("lang", item.alias);
            handleClose();

            // بعد از تکمیل تمام تغییرات
            location.reload();
          }
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <Container
      maxWidth="xlg"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        backgroundColor: theme === 'dark' ? "#3c3c3c" : "white",
      }}
    >
      <Stack
        direction="row-reverse"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" flexDirection="row-reverse" alignItems="center">
          {currentUser && (
            <AccountSwitcher
              className={headerData.avatar}
              picture={storedProfile?.picture || currentUser?.picture || ""}
            />
          )}

          {permissionsReady && <TimeEntryTimer compact />}

          {permissionsReady && canShowWalletHeader() && (
            <IconButton onClick={() => navigate(getWalletHomePath())}>
              <AccountBalanceWalletIcon />
            </IconButton>
          )}

          <div>
            <IconButton id="language-menu" onClick={handleClick}>
              <LanguageOutlinedIcon />
            </IconButton>
            {languaes?.length > 0 && (
              <Menu
                id="language-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {languaes.map(
                  (item) =>
                    item.file && (
                      <MenuItem
                        key={item.id}
                        onClick={
                          item.RTL == "yes"
                            ? handleChangeToRtl.bind(null, item)
                            : handleChangeToLtr.bind(null, item)
                        }
                      >
                        {item?.name}
                      </MenuItem>
                    )
                )}
              </Menu>
            )}
          </div>
          <IconButton
            onClick={() => {
              markAllRead();
              navigate("notifications");
            }}
          >
            <Badge badgeContent={unreadCount > 0 ? unreadCount : null} color="error" max={99}>
              <NotificationsNoneOutlinedIcon />
            </Badge>
          </IconButton>
          <ThemeSetting />
        </Box>
        <Box sx={{ display: 'flex' }}>
          <IconButton onClick={toggle}>
            <DehazeIcon />
          </IconButton>
          <TextField
            className={headerData.search}
            sx={{ display: { md: 'inline-block', xs: 'none' }, marginLeft: { md: 2, lg: 3} }}
            size="small"
            id="input-with-icon-textfield"
            placeholder={StrinLocalized.Search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            variant="outlined"
          />
        </Box>
      </Stack>
    </Container>
  );
};

export default Header;
